import { User } from 'ComponentLibrary/src/common/users'
import { UsersAutocomplete } from './UserAutocomplete'
import { type UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'

type ParticipantsAutocompleteProps = {
    users: User[]
    newParticipants: User[]
    setNewParticipants: (participants: User[]) => void
    disabled?: boolean
    label?: string
    userLinkCopy?: Partial<UserLinkCopy>
}

export const ParticipantsAutocomplete = ({
    users,
    newParticipants,
    setNewParticipants,
    disabled,
    label = 'Weitere Benachrichtigte hinzufügen...',
    userLinkCopy,
}: ParticipantsAutocompleteProps) => {
    return (
        <UsersAutocomplete
            multiple
            users={users}
            value={newParticipants}
            onChange={setNewParticipants}
            disabled={disabled}
            label={label}
            userLinkCopy={userLinkCopy}
        />
    )
}
